import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken } from "../lib/api";
import { track } from "../lib/tracking";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out, object = user
  const [ready, setReady] = useState(false);

  const load = useCallback(async () => {
    const token = localStorage.getItem("agni_token");
    if (!token) { setUser(false); setReady(true); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch (e) {
      setToken(null);
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const finishAuth = (data, isNew) => {
    setToken(data.token);
    setUser(data.user);
    if (isNew) track("CompleteRegistration"); else track("Login");
    return data.user;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    return finishAuth(data, false);
  };
  const register = async (payload) => {
    const sid = localStorage.getItem("agni_session");
    const { data } = await api.post(`/auth/register${sid ? `?session_id=${sid}` : ""}`, payload);
    return finishAuth(data, true);
  };
  const otpVerify = async (payload) => {
    const { data } = await api.post("/auth/otp/verify", payload);
    return finishAuth(data, false);
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setToken(null);
    setUser(false);
  };
  const updateUser = (u) => setUser(u);

  return (
    <AuthContext.Provider value={{ user, ready, login, register, otpVerify, logout, refresh: load, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}
